import React from "react";
import BookingDropCauseInput from "../BookingDropCauseInput";
import DropIcon from "@material-ui/icons/Delete";
import { DateTimeInput, TextInput, required, useLocale, useTranslate } from "react-admin";
import { Typography } from "@material-ui/core";
import { UpdateWithFormButton } from "../../../component/button";
import { dateTimeOptions } from "../../../util/dates";

const validate = [required()];

const BookingDropButton = props => {
    const locale = useLocale();
    const translate = useTranslate();
    const dateTimeFormatter = new Intl.DateTimeFormat(locale, dateTimeOptions);
    const { record } = props;
    const { checkInAt, emailAddress, locator } = record;
    const droppedAt = new Date();
    const date = new Date(Date.parse(checkInAt));

    return (
        <UpdateWithFormButton
            action="drop"
            icon={<DropIcon />}
            initialValues={{
                droppedAt,
                emailAddress,
                locator,
            }}
            path="drop/"
            resource="booking"
            {...props}
        >
            {
                date && (
                    <Typography color="textSecondary" gutterBottom variant="body2">
                        {translate("booking.message.dropUntil", {
                            date: dateTimeFormatter.format(date),
                        })}
                    </Typography>
                )
            }
            <DateTimeInput
                fullWidth
                label={translate("booking.label.droppedAt")}
                source="droppedAt"
                options={dateTimeOptions}
            />
            <BookingDropCauseInput
                fullWidth
                label={translate("booking.label.dropCause")}
                source="dropCause"
                validate={validate}
            />
            <TextInput
                fullWidth
                label={translate("booking.label.dropNotes")}
                multiline
                resettable
                source="dropNotes"
            />
        </UpdateWithFormButton>
    );
};

export default BookingDropButton;
